import * as React from 'react';
import { FC } from 'react';
import * as CheckboxElement from '@radix-ui/react-checkbox';
import * as styles from './styles.css';
import cn from 'clsx';
import { IconSuccess } from '../Icons/IconSuccess';
import { Typography } from '../Typography';

interface ICheckboxProps {
  isChecked: boolean;
  setChecked: (state: boolean) => void;
  label: string | React.ReactElement;
  description?: string;
  isDisabled?: boolean;
  isError?: boolean;
  id: string;
}

export const Checkbox: FC<ICheckboxProps> = ({
  isChecked,
  setChecked,
  description,
  label,
  isDisabled = false,
  isError = false,
  id,
}) => {
  return (
    <div className={cn(styles['checkbox-container'], isError && styles['error'])}>
      <CheckboxElement.Root
        className={cn(styles['checkbox'], isChecked && styles['checked'])}
        checked={isChecked}
        onCheckedChange={setChecked}
        disabled={isDisabled}
        id={`checkbox-${id}`}
      >
        <span className={cn(styles['indicator'], { [styles['checked']]: isChecked })}>
          <IconSuccess color={'currentColor'} />
        </span>
        <div className={styles['checkbox-content']}>
          <label className={styles['label']} htmlFor={`checkbox-${id}`}>
            <Typography.Text level={3} color="currentColor">
              {label}
            </Typography.Text>
          </label>
          {description && (
            <div className={styles['description']}>
              <Typography.Text level={4} color="currentColor">
                {description}
              </Typography.Text>
            </div>
          )}
        </div>
      </CheckboxElement.Root>
    </div>
  );
};
